import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { actions } from '@/shared/store/actions.ts';
import { getters } from '@/shared/store/getters.ts';
import { mutations } from '@/shared/store/mutations.ts';
import { RootState } from '@/shared/store/types.ts';
import { economic } from '@/economic/store';
import { LOCALE_CODE_DA } from '@/i18n';

Vue.use(Vuex);

export const storeOptions: StoreOptions<RootState> = {
  state: {
    step: 1,
    signupData: {
      acceptedTermsAndAgreements: false,
      orgLogo: null,
      orgName: '',
      orgType: null,
      orgSizeInterval: null,
      orgCVR: '',
      password: '',
      repeatedPassword: '',
      personEmail: '',
      personName: '',
      personPhone: '',
      personPicture: null,
      receiveNewsletters: false,
      locale: LOCALE_CODE_DA,
      signupType: '',
      integrationData: null,
    },
  },

  actions,
  mutations,
  getters,

  modules: {
    economic,
  },
};

export default new Vuex.Store(storeOptions);
